import Utils from "../../../utility";

const initialState = {
  list: [],
  count: 0,
};

export const b2bBrandBannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case Utils.ActionName.B2B_BRAND_BANNER:
      return { ...state, ...action.payload };
    case Utils.ActionName.RESET_B2B_BRAND_BANNER:
      return { ...initialState };
    default:
      return state;
  }
};
